import React from 'react';
import { Form } from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';
import Dialog from 'components/DesignSystem/Dialog';
import TextField from 'components/DesignSystem/TextField';

interface FormSalvarProps {
  open: boolean;
  isSaving: boolean;
  nome: string;
  onNomeChange: (nome: string) => void;
  onDismiss: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

/**
 * Dialog "dar nome e salvar" das Preferencias Salvas.
 *
 * Fica FORA da casca (irmao do `Accordion.Item` no desktop, irmao do `Section`
 * no mobile) porque quem o abre e um botao externo: "Salvar preferência" no
 * `Actions` do desktop e no rodape do BottomSheet no mobile — que continua
 * visivel com a secao fechada.
 */
export default function FormSalvar({
  open, isSaving, nome, onNomeChange, onDismiss, onSubmit,
}: FormSalvarProps) {
  return (
    <Dialog open={open} dismiss={onDismiss} closeButton>
      <Dialog.Body>
        <Form onSubmit={onSubmit}>
          <p className="mb-3">
            Antes de salvar, dê um
            {' '}
            <strong>nome</strong>
            {' '}
            para sua nova preferência.
          </p>
          <TextField
            controlId="windx-nome-preferencia"
            placeholder="Nome da preferência"
            value={nome}
            onChange={(e) => onNomeChange((e.target as HTMLInputElement).value)}
            aria-label="Nome da nova preferência"
          />
          <div className="mt-3">
            <Button
              submit
              type="primary"
              disabled={isSaving || !nome.trim()}
            >
              {isSaving ? 'Salvando…' : 'Salvar nova preferência'}
            </Button>
          </div>
        </Form>
      </Dialog.Body>
    </Dialog>
  );
}
